import $ from 'jquery';
import constants from 'Constants.js';
import _ from 'lodash';
import { View } from 'backbone';
import Template from 'report/properties/main/crosstab.ejs';
import listService from 'ListService';
import util from 'util/Util.js';
import MainFormulaModal from 'common-views/MainFormulaModalView.js';

class MainCrosstabColumnsView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.config = opts.config || {};

        this.events = {
            'click #groupFormula, #sideFormula, #typeFormula' :'updateGroupOrValue',
            "change select"            : 'updateSelectAttributes'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }


    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;


        if (propName === 'groupTop' || propName === 'groupSide' || propName ==='valueMath' || propName === 'valueType') {
            let colid = "0";

            if (propName === 'groupSide') {
                colid = "1";
            }else if(propName === 'valueMath' || propName === 'valueType'){
                colid = "2";
            }

            if (propName === 'valueMath') {
                this.updateColumnProperty(colid, 'aggregation', propVal);
                this.updateReportingMetaDataColumn(colid, 'aggregation', propVal);
            } else {

                const dataType=$(ev.currentTarget).find(":selected").attr("datatype");
                this.updateColumnProperty(colid, 'fieldId', listService.getCleanedId(propVal));
                this.updateColumnProperty(colid, 'fieldDataType', dataType);
                this.updateReportingMetaDataColumnField(colid, listService.getCleanedId(propVal), dataType);
            }
        }

        this.model.set( propName, propVal, {silent:true} );
    }

    updateReportingMetaDataColumn(rowid, propName, propVal) {
        const md = listService.getReportingMetaData(this.model.get('id'));

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    col[propName] = propVal;
                }
            });
        }
    }

    updateReportingMetaDataColumnField(rowid, dsFieldId, dataType, data ) {
        let md = listService.getReportingMetaData(this.model.get('id'));

        if(!md){
            listService.setReportingMetaData(this.model.get('dataSourceId'), this.model, true);
            md = listService.getReportingMetaData(this.model.get('id'));
        }

        if (md.Columns) {
            _.forEach(md.Columns, (col) => {
                if (col.id.toString() === rowid.toString()) {
                    let aggregate = 'group';
                    if(col.id.toString() === '2'){
                        aggregate = $('#valueMath option:selected').val();
                    }
                    col.aggregation = aggregate;

                    if( data && data.arguments && util.isChart(this.model.get('factoryKey')) ){
                        col.Expression.id = data.id;
                        col.Expression.type = data.type;
                        col.Expression.Argument = data.arguments;
                    }else{
                        col.Expression.Argument = {type: 'reporting_datasourceField', value: dsFieldId, dataType: dataType};
                    }
                }
            });
        }
    }

    updateColumnProperty(rowid, propName, propVal) {
        const columns = this.model.get('Columns');

        columns.Column[rowid].Properties[propName] = propVal;
    }

    updateGroupOrValue(ev){
        this.model.set('formulaType', ev.target.name, {silent:true});
        this.model.set('type', 'DataSource', {silent:true});
        this.model.set('title', 'Column Formula', {silent:true});
        var formulaModal = new MainFormulaModal({model:this.model});
        formulaModal.render().then((data)=>{
            if (ev.target.name === 'groupFormula'){
                this.updateColumnProperty('0', 'fieldId', 'Formula');
                this.updateColumnProperty('0', 'fieldDataType', 'NVARCHAR(400)');
                this.updateColumnProperty('0', 'usesExpression', 'true');
                this.updateReportingMetaDataColumnField('0', 'Formula', 'NVARCHAR(400)', data); 
                this.updateColumnExpression('0');
                this.model.set( 'groupTop', 'Formula', {silent:true} );
            }else if (ev.target.name === 'sideFormula'){
                this.updateColumnProperty('1', 'fieldId', 'Formula');
                this.updateColumnProperty('1', 'fieldDataType', 'NVARCHAR(400)');
                this.updateColumnProperty('1', 'usesExpression', 'true');
                this.updateReportingMetaDataColumnField('1', 'Formula', 'NVARCHAR(400)', data); 
                this.updateColumnExpression('1');
                this.model.set( 'groupSide', 'Formula', {silent:true} );
            }else if(ev.target.name === 'typeFormula'){
                this.updateColumnProperty('2', 'fieldId', 'Formula');
                this.updateColumnProperty('2', 'fieldDataType', 'NVARCHAR(400)');
                this.updateColumnProperty('2', 'usesExpression', 'true');
                this.updateReportingMetaDataColumnField('2', 'Formula', 'NVARCHAR(400)', data); 
                this.updateColumnExpression('2');
                this.model.set( 'valueType', 'Formula', {silent:true} );
            }
            this.model.set(ev.target.name,data, {silent:false});
            this.render();
        }).catch(e => {
            console.log(e);
        });
    }

    updateColumnExpression(rowid) {
        const groupFormula = this.model.get('groupFormula');
        const sideFormula = this.model.get('sideFormula');
        const typeFormula = this.model.get('typeFormula');
        const columns = this.model.get('Columns');

        if (groupFormula && rowid.toString() === '0'){
            if (!columns.Column[rowid].EXPR){
                columns.Column[rowid].EXPR = {id: groupFormula.id,
                                              type: groupFormula.type,
                                              arguments: groupFormula.arguments
                                             };            
            }else{
                columns.Column[rowid].EXPR.id = groupFormula.id;
                columns.Column[rowid].EXPR.type = groupFormula.type;
                columns.Column[rowid].EXPR.arguments = groupFormula.arguments;
            }
        }

        if (sideFormula && rowid.toString() === '1'){
            if (!columns.Column[rowid].EXPR){
                columns.Column[rowid].EXPR = {id: sideFormula.id,
                                              type: sideFormula.type,
                                              arguments: sideFormula.arguments  
                                             };        
            }else{
                columns.Column[rowid].EXPR.id = sideFormula.id;
                columns.Column[rowid].EXPR.type = sideFormula.type;
                columns.Column[rowid].EXPR.arguments = sideFormula.arguments;
            }
        }

        if (typeFormula && rowid.toString() === '2'){
            if (!columns.Column[rowid].EXPR){
                columns.Column[rowid].EXPR = {id: typeFormula.id,
                                              typ: typeFormula.type,
                                              arguments: typeFormula.arguments
                                             };        
            }else{
                columns.Column[rowid].EXPR.id = typeFormula.id;
                columns.Column[rowid].EXPR.type = typeFormula.type;
                columns.Column[rowid].EXPR.arguments = typeFormula.arguments;
            }
        }

      }

    // Only want to list Fields marked as InUse (Configured in the DataSource)
    loadFieldsFromDatasource( dsId ) {
        if(!dsId){
            return;
        }
        const ds = listService.getDataSources(listService.cleanId(dsId));

        if (ds && ds.Fields && ds.Fields.Field) {

            const fieldGroupEl = $('#groupTop');
            const fieldValueEl = $('#groupSide');
            const fieldTypeEl = $('#valueType');

            _.forEach(ds.Fields.Field, (field) => {
                if (util.isTrue(field.inUse)) {
                    let fname = '';

                    switch (field.id) {
                        case 'CreateDate':
                            fname = 'Meta - Last Submission Date';
                            break;
                        case 'E':
                            fname = 'Meta - Instance Number';
                            break;
                        case 'FormInstanceGUID':
                            fname = 'Meta - Instance ID';
                            break;
                        case 'FormInstanceId':
                            fname = 'Meta - Link';
                            break;
                        case 'MajorVersion':
                            fname = 'Meta - Version Major';
                            break;
                        case 'MinorVersion':
                            fname = 'Meta - Version Minor';
                            break;
                        case 'Name':
                            fname = 'Meta - Instance Name';
                            break;
                        case 'ParentGUID':
                            fname = 'Meta - Parent Instance ID';
                            break;
                        case 'StageName':
                            fname = 'Meta - Stage';
                            break;

                        default:
                            fname = field.name.replace('|',' - ');
                            break;
                    }

                    const elOpt = new Option((field.displayName.trim() || fname), field.id);
                    fieldGroupEl[0].options[fieldGroupEl[0].options.length] = elOpt;
                    elOpt.setAttribute("dataType", field.dataType);

                    const elOpt2 = new Option((field.displayName.trim() || fname), field.id);
                    fieldValueEl[0].options[fieldValueEl[0].options.length] = elOpt2;
                    elOpt2.setAttribute("dataType", field.dataType);

                    const elOpt3 = new Option((field.displayName.trim() || fname), field.id);
                    fieldTypeEl[0].options[fieldTypeEl[0].options.length] = elOpt3;
                    elOpt3.setAttribute("dataType", field.dataType);
                   
                }
            });

            $('#groupTop').append('<optgroup label="──────────"></optgroup>');
            $('#groupTop').append('<option value="Formula" datatype="NVARCHAR(400)">Formula</option>');
            $('#groupSide').append('<optgroup label="──────────"></optgroup>');
            $('#groupSide').append('<option value="Formula" datatype="NVARCHAR(400)">Formula</option>');
            $('#valueType').append('<optgroup label="──────────"></optgroup>');
            $('#valueType').append('<option value="Formula" datatype="NVARCHAR(400)">Formula</option>');
        }
    }

    setFieldsFromColumns() {
        const columns = this.model.get('Columns');
        
        const grpColValue = columns.Column[0].Properties.fieldId;
        this.model.set('groupTop', grpColValue, {silent:true});

        const grpColValue2 = columns.Column[1].Properties.fieldId;
        this.model.set('groupSide', grpColValue2, {silent:true});

        const valColValue = columns.Column[2].Properties.fieldId;
        const valColAgg = columns.Column[2].Properties.aggregation;
        this.model.set('valueType', valColValue, {silent:true});
        this.model.set('valueMath', valColAgg, {silent:true});
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.loadFieldsFromDatasource(this.model.get('dataSourceId'));

        this.setFieldsFromColumns();

        let valueType = this.model.get('valueType');

        if(valueType.toLowerCase() !== "formula"){
            valueType = listService.cleanId(valueType)
        }
        else{
            valueType = valueType[0].toUpperCase() + valueType.slice(1); //In case the F in formula is in lower case
        }
 
        $("#groupTop option[value='" + this.model.get('groupTop') + "']").prop('selected', true);
        $("#groupSide option[value='" + this.model.get('groupSide') + "']").prop('selected', true);
        $("#valueType option[value='" + valueType + "']").prop('selected', true);
        $("#valueMath option[value='" + this.model.get('valueMath') + "']").prop('selected', true);

        this.delegateEvents();
        return this;
    }    
}

export default MainCrosstabColumnsView;
